export default __webpack_public_path__ + "static/media/primelocation.485fc48b.avif";